import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { BusEvent } from './models/bus-event';

@Injectable({ providedIn: 'root' })
export class ServiceBus {
  private static eventBus: Subject<BusEvent> = new Subject<BusEvent>();

  public publish<K extends keyof T, T>(name: K, payload: T[K]) {
    ServiceBus.eventBus.next({ name: name as string, payload });
  }

  public on<K extends keyof T, T>(name: K): Observable<T[K]> {
    return ServiceBus.eventBus.asObservable().pipe(
      filter(event => event.name === name),
      map(event => event.payload as T[K]),
    );
  }
}
